import React from 'react';
import ReactDOM from 'react-dom/client';
import {Provider} from "react-redux";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/scrollbar';
import './index.scss';

import './locales/config';
import App from './App';
import {store} from "./redux/store";
import history from "./utils/helpers/history";
import {BrowserRouter} from "./utils/helpers/browser-router";
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter history={history}>
        <App />
      </BrowserRouter>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
